export default "__VITE_ASSET__c38b303c__"